import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorHandlerHelperDirective } from '../../../../common/error-handler/error-handler-helper.directive.';
import { ErrorHandlerDirective } from '../../../../common/error-handler/error-handler.directive';
import { ContentAirportLookup } from '../../../../model/content/contentAirportLookup.model';
import { ContentBook } from '../../../../model/content/contentbook.model';
import { ContentHeaderFooterService } from '../../../../services/content/contentheaderfooter.service';
import { SearchService } from '../../../../services/search/search.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngc-flightitem',
  templateUrl: 'flightitem.component.html'
})
export class FlightItemComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild('fromAirportElement') fromAirportElementRef: ElementRef;
  @Input() index: number;
  @Input() flightFormGroup: UntypedFormGroup;
  @Input() bookContent: ContentBook;
  @Input() errorHandler: ErrorHandlerDirective;
  @ViewChild(ErrorHandlerHelperDirective)
  errorHandlerHelper: ErrorHandlerHelperDirective;

  @Input() flightData;
  indexOfItemInErrorDirective;
  tofieldErr = false;
  fromAirportcode = '';
  fromCity = '';
  toAirportcode = '';
  toCity = '';
  fromCountryCode = '';
  toCountryCode = '';
  connection = '';
  forHiddendepartureDate = '';
  fromAirportLabel = 'From';
  toAirportLabel = 'To ';
  content: any;
  mpmRestriction = '';
  milesRestriction = '';
  airportLookupContent: ContentAirportLookup;
  odPairRestriction: string;
  contentServiceHeaderFooterSubscribe: Subscription;
  @Output() destAirportSet = new EventEmitter();
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private searchService: SearchService,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    this.fromAirportcode =
      this.flightData &&
      this.flightData.airports &&
      this.flightData.airports.fromAirportcode
        ? this.flightData.airports.fromAirportcode
        : '';
    this.fromCity =
      this.flightData &&
      this.flightData.airports &&
      this.flightData.airports.fromCity
        ? this.flightData.airports.fromCity
        : '';
    this.toAirportcode =
      this.flightData &&
      this.flightData.airports &&
      this.flightData.airports.toAirportcode
        ? this.flightData.airports.toAirportcode
        : '';
    this.toCity =
      this.flightData &&
      this.flightData.airports &&
      this.flightData.airports.toCity
        ? this.flightData.airports.toCity
        : '';
    this.fromCountryCode = this.flightData?.airports?.fromCountryCode ?? '';
    this.toCountryCode = this.flightData?.airports?.toCountryCode ?? '';
    this.connection =
      this.flightData && this.flightData.connectionAirport
        ? this.flightData.connectionAirport
        : '';
    this.forHiddendepartureDate =
      this.flightData && this.flightData.departureDate
        ? this.flightData.departureDate
        : '';
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.content =
                  data.header.primaryNavigations.get('book').details;
                this.airportLookupContent = data.airportLookup;
                this.odPairRestriction =
                  this.airportLookupContent.odPairRestriction;
                this.setAemValues();
                this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
    this.flightFormGroup
      .get('departureDate')
      .valueChanges.pipe(takeUntil(this.unsubscribe))
      .subscribe((value) => {
        if (value && this.forHiddendepartureDate !== value) {
          this.forHiddendepartureDate = value;
          this.flightFormGroup.get('departureDate').markAsTouched();
          this.cdf.detectChanges();
        }
      });
  }

  ngAfterViewInit() {
    if (
      this.errorHandler &&
      this.errorHandler instanceof ErrorHandlerDirective
    ) {
      this.indexOfItemInErrorDirective =
        this.errorHandler.addErrorHandlerHelper(this.errorHandlerHelper);
    }
  }

  ngOnChanges(chnages: SimpleChanges) {
    if (this.fromAirportcode === this.bookContent.fromLabel) {
      this.fromAirportcode = this.bookContent.multicityFromLabel;
    }
    if (this.toAirportcode === this.bookContent.toLabel) {
      this.toAirportcode = this.bookContent.multicityToLabel;
    }
  }

  inputFocus(event) {}

  inputBlur(event) {
    this.forHiddendepartureDate =
      this.flightFormGroup.get('departureDate').value;
  }

  swapCity() {
    const from = this.fromAirportcode;
    const to = this.toAirportcode;
    const fromCode = this.fromCountryCode;
    const toCode = this.toCountryCode;
    const fromCity = this.fromCity;
    const toCity = this.toCity;
    this.fromAirportcode = to;
    this.toAirportcode = from;
    this.fromCity = toCity;
    this.toCity = fromCity;
    this.fromCountryCode = toCode;
    this.toCountryCode = fromCode;
    if (this.odPairRestriction.toLowerCase() === 'true') {
      this.getODPairAttributes();
    }
  }

  getODPairAttributes() {
    this.searchService.airportUpdate
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((value) => {
        if (value && value.length > 0) {
          const airport = value[0];
          if (
            airport.restrictNonJvPartner !== undefined &&
            airport.restrictNonJvPartner === 'FALSE'
          ) {
            this.toAirportcode = '';
            this.toCountryCode = '';
            this.toCity = '';
          }
          this.destAirportSelected(value[0]);
        } else {
        }
      });
    this.searchService.getCitiesAttributes(
      this.toAirportcode,
      this.fromAirportcode
    );
  }

  markAsTouchedFrom() {
    (
      this.flightFormGroup as UntypedFormGroup
    ).controls.connectionAirport.setValue(this.connection);
    (
      this.flightFormGroup as UntypedFormGroup
    ).controls.connectionAirport.markAsTouched({ onlySelf: true });
    this.flightFormGroup.controls.connectionAirport.markAsTouched({
      onlySelf: true
    });
  }

  ngOnDestroy() {
    if (this.errorHandler) {
      this.errorHandler.removeErrorHanlderHelper(
        this.indexOfItemInErrorDirective
      );
    }
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }

  setAemValues() {
    this.fromAirportLabel = this.content.multicityFromLabel;
    this.toAirportLabel = this.content.multicityToLabel;
  }

  destAirportSelected(airports) {
    if (this.toAirportcode && this.toAirportcode !== '') {
      const selectAirportData = [];
      selectAirportData[0] = airports.airportCode;
      selectAirportData[1] = airports.city;
      selectAirportData[2] = this.index;
      selectAirportData[3] = this.odPairRestriction;
      selectAirportData[4] = airports.restrictMPM;
      selectAirportData[5] = airports.restrictMiles;
      selectAirportData[6] = airports.restrictCash;
      selectAirportData[7] = airports?.countryCode ?? '';
      this.destAirportSet.emit(selectAirportData);
      this.cdf.detectChanges();
    }
  }

  resetToAirport() {
    if (this.odPairRestriction.toString().toLowerCase() === 'true') {
      this.toAirportcode = '';
      this.toCountryCode = '';
      this.toCity = '';
    }
  }

  mcityairportFieldFocus(index) {
    if (!this.fromAirportcode || this.fromAirportcode === '') {
      const fromtarget = 'fromAirportLink' + index;
      this.tofieldErr = false;
      return fromtarget;
    }
    if (!this.toAirportcode || this.toAirportcode === '') {
      const totarget = 'toAirportLink' + index;
      this.tofieldErr = true;
      return totarget;
    }
  }
}
